import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "./Particle";
import ml2 from "./ml2.jpg";
import ml from "./ml.png";
import cart from "./logo.png";
import crude from "./crude-oil-16542323314x3 (1).webp";
import cloud from "./cloud.jpg";
import classimg from "./image.jpg";
import water from "./water.jpeg";
import logo from "./tri.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading myfont ">My Projects</h1>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          

          <Col md={5} className="project-card">
            <ProjectCard
              imgPath={cart}
              isBlog={false}
              title="Personal Portfolio"
              description="My personal portfolio developed using ReactJs which you are currently seeing at."
              ghLink="https://github.com/AntonyJudeShaman/Portfolio-2.0"
            />
          </Col>
          <Col md={5} className="project-card">
            <ProjectCard
              imgPath={logo}
              isBlog={true}
              title="Tri2Champ"
              description="Commercial Sports Website with functionalities like User &
              Admin login, Event registration, Payment Gateway using ReactJs, Bootstrap,
              Tailwind, Firebase, Vercel and Razorpay"
              ghLink="https://www.tri2champ.com"
            />
          </Col>
          <Col md={5} className="project-card">
            <ProjectCard
              imgPath={crude}
              isBlog={false}
              title="Crude Oil Price Prediction"
              description="A model that predicts future crude oil prices based on the
              datasets ."
              ghLink="https://github.com/AntonyJudeShaman/Crude-Oil-Price-Prediction"
            />
          </Col>
          <Col md={5} className="project-card">
            <ProjectCard
              imgPath={cloud}
              isBlog={false}
              title="Weather Web-App"
              description="A weather forecasting app created with Streamlit. It can forecast 5 days of weather data with an interval of 3 hours. "
              ghLink="https://github.com/AntonyJudeShaman/weather-app"
            />
          </Col>
          <Col md={5} className="project-card">
            <ProjectCard
              imgPath={classimg}
              isBlog={false}
              title="Image Classification"
              description="A image classification model trained on animal-10 dataset using MobileNetV2"
              ghLink="https://github.com/AntonyJudeShaman/Image-Classification"
            />
          </Col>
          <Col md={5} className="project-card">
            <ProjectCard
              imgPath={water}
              isBlog={false}
              title="Water Quality Detection"
              description="A model trained to detect the potability of municipality water for safe consumption by humans"
              ghLink="https://github.com/AntonyJudeShaman/Water-quality"
            />
          </Col>
          <Col md={5} className="project-card">
            <ProjectCard
              imgPath={ml}
              isBlog={false}
              title="Generative Adversarial Network"
              description="A simple GAN that was trained on the MNIST data with 20 epochs. "
              ghLink="https://github.com/AntonyJudeShaman/Simple-GAN"
            />
          </Col>
         

          <Col md={5} className="project-card">
            <ProjectCard
              imgPath={ml2}
              isBlog={false}
              title="Life Expectancy Prediction"
              description="A Model trained on the World Health Organization's life expectancy Dataset. It  is  a  Linear Regression."
              ghLink="https://github.com/AntonyJudeShaman/life-expectancy-prediction"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
